import { useEffect, useState } from "react";

/**
 * Slim fixed reading-progress bar that fills as the user scrolls the page.
 * Updates a GPU-composited transform (scaleX) inside a rAF, so scroll frames
 * don't invalidate layout (no per-frame width writes -> fewer forced reflows).
 */
const ReadingProgress = () => {
  const [progress, setProgress] = useState(0); // 0..1, drives scaleX

  useEffect(() => {
    let rafId: number | null = null;

    const update = () => {
      rafId = null;
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? Math.min(1, Math.max(0, scrollTop / docHeight)) : 0;
      setProgress(pct);
    };

    const onScroll = () => {
      if (rafId === null) rafId = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (rafId !== null) window.cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div
      className="reading-progress"
      style={{ transform: `scaleX(${progress})` }}
      aria-hidden="true"
      role="presentation"
    />
  );
};

export default ReadingProgress;
